// @ts-check
import { randomString } from '@/Helpers/strings';
import { utcToLocal } from '@/Helpers/time';
import { required, numeric } from '@vuelidate/validators';

export class StudyTaskNotificationModel {
  constructor({
    Id = null,
    StudyTaskId,
    NotificationText,
    DaysAfterTask,
    SentDate,
    RedcapVariable = null
  }) {
    this._modelName = 'StudyTaskNotification';
    this.Id = Id;
    this.StudyTaskId = StudyTaskId;
    this.NotificationText = NotificationText;
    this.DaysAfterTask = DaysAfterTask;
    this.SentDate = SentDate ? utcToLocal(SentDate) : null;
    this.RedcapVariable = RedcapVariable;

    this._sortableKey = randomString();
  }

  __copy() {
    return JSON.parse(JSON.stringify(this));
  }

  static get validations() {
    return {
      Id: {},
      NotificationText: {},
      DaysAfterTask: {
        required,
        numeric
      },
      SentDate: {}
    };
  }
}

export default StudyTaskNotificationModel;
